/*! gsap.hoverChase.js | v3.0.0 | license Copyright (C) 2019 - 2022 Taichi Matsutaka */
/**
 *
 * @name    : gsap.hoverChase.js
 * @content : plugin
 * @url     : https://github.com/taichaaan/js-gsap-hoverChase
 * @creation: 2019.05.09
 * @update  : 2022.08.22
 * @version : 3.0.0
 *
 * @useLibrary : gsap.js
 *
 */
(function(global) {[]
	global.hoverChase = function(node,options){
		///////////////////////////////////////////////////////////////
		// defaults options
		///////////////////////////////////////////////////////////////
		this.nodeElements = Array.prototype.slice.call( document.querySelectorAll( node ) ,0) ;
		const _this = this;

		const defaults = {
			addClass   : 'is-chase',
			amount     : .8,
			moveSpeed  : .4,
			moveEasing : Power1.easeOut,
			leaveEpeed : .8,
			leaveEasing: Elastic.easeOut.config(1, 0.3),
			slope      : null,
			getWindowSizeEvent: ['DOMContentLoaded','resize'],
			getSizeEvent      : ['DOMContentLoaded','load','resize'],
			getOffsetEvent    : ['load','resize','scroll'],
		}


		///////////////////////////////////////////////////////////////
		// options
		///////////////////////////////////////////////////////////////
		for( let option in options){
			defaults[option] = options[option];
		}
		this.options = defaults;


		///////////////////////////////////////////////////////////////
		// base
		///////////////////////////////////////////////////////////////
		this.removes = [];
		this.base();


	};
	hoverChase.prototype = {
		base: function(){
			const _this   = this;
			const options = this.options;


			///////////////////////////////////////////////////////////////
			// window size
			///////////////////////////////////////////////////////////////
			let windowWidth  = window.innerWidth;
			let windowHeight = document.documentElement.clientHeight;

			const getWindowSize = function(){
				windowWidth  = window.innerWidth;
				windowHeight = document.documentElement.clientHeight;
			}

			for ( let i = 0; i < options['getWindowSizeEvent'].length; i++ ) {
				window.addEventListener( options['getWindowSizeEvent'][i] ,getWindowSize);

				/* ---------- removes ---------- */
				_this.removes.push( function(){
					window.removeEventListener( options['getWindowSizeEvent'][i] ,getWindowSize);
				});
			}




			///////////////////////////////////////////////////////////////
			// mousemove
			///////////////////////////////////////////////////////////////
			let mouse_clientX = 0;
			let mouse_clientY = 0;

			const getMouseClient = function(){
				mouse_clientX = event.clientX;
				mouse_clientY = event.clientY;
			}




			///////////////////////////////////////////////////////////////
			// getSlopeValue
			///////////////////////////////////////////////////////////////
			let getSlopeValue = function(mouseX){
				return 1;
			}

			if( options['slope'] != null ){
				getSlopeValue = function(mouseX){
					return mouseX * options['slope'];
				}
			}




			this.nodeElements.forEach(function(target) {
				///////////////////////////////////////////////////////////////
				// variable
				///////////////////////////////////////////////////////////////
				let width      = 0;
				let height     = 0;
				let widthHalf  = width * .5;
				let heightHalf = height * .5;

				let boundingClient     = 0;
				let boundingClientTop  = 0;
				let boundingClientLeft = 0;



				///////////////////////////////////////////////////////////////
				// getSize
				///////////////////////////////////////////////////////////////
				const getSize = function(){
					width      = target.clientWidth;
					height     = target.clientHeight;
					widthHalf  = width * .5;
					heightHalf = height * .5;
				};

				for ( let i = 0; i < options['getSizeEvent'].length; i++ ) {
					window.addEventListener( options['getSizeEvent'][i] ,getSize);

					/* ---------- removes ---------- */
					_this.removes.push( function(){
						window.removeEventListener( options['getSizeEvent'][i] ,getSize);
					});
				}




				///////////////////////////////////////////////////////////////
				// getOffset
				///////////////////////////////////////////////////////////////
				const getOffset = function(){
					boundingClient     = target.getBoundingClientRect();
					boundingClientTop  = boundingClient.top;
					boundingClientLeft = boundingClient.left;
				};

				for ( let i = 0; i < options['getOffsetEvent'].length; i++ ) {
					window.addEventListener( options['getOffsetEvent'][i] ,getOffset);

					/* ---------- removes ---------- */
					_this.removes.push( function(){
						window.removeEventListener( options['getOffsetEvent'][i] ,getOffset);
					});
				}




				///////////////////////////////////////////////////////////////
				// mousemove mouseleave
				///////////////////////////////////////////////////////////////
				const animationIn = function(){
					getMouseClient();

					const centerY     = boundingClientTop + heightHalf;
					const centerX     = boundingClientLeft + widthHalf;
					const mouseX      = ( mouse_clientX - centerX ) * options['amount'];
					const mouseY      = ( mouse_clientY - centerY ) * options['amount'];
					const slope_value = getSlopeValue(mouseX);

					gsap.to( this , options['moveSpeed'] ,{
						ease    : options['moveEasing'],
						x       : mouseX,
						y       : mouseY,
						rotation: slope_value,
					});

					this.classList.add( options['addClass'] );
				}

				const animationOut = function(){
					gsap.to( this , options['leaveEpeed'] ,{
						ease    : options['leaveEasing'],
						x       : 0,
						y       : 0,
						rotation: 0,
					});

					this.classList.remove( options['addClass'] );
				}

				target.addEventListener('mousemove',animationIn);
				target.addEventListener('mouseleave',animationOut);

				/* ---------- removes ---------- */
				_this.removes.push( function(){
					target.removeEventListener('mousemove',animationIn);
					target.removeEventListener('mouseleave',animationOut);
				});


			});
		},
		remove: function(){
			/* removes に追加された関数をforで一つずつ実行する。 */
			const removes = this.removes;

			if( !removes ) return;

			for ( let i = 0; i < removes.length; i++ ) {
				removes[i]();
			}
		},
	};

})(this);
